import React from "react";
import StackIcon from "tech-stack-icons";

const experienceData = [
    { icon: <StackIcon name={"kubernetes"} className="w-12" />, years: 3, label: 'Kubernetes'},
    { icon: <StackIcon name={"docker"} className="w-12" />, years: 6, label: 'Docker'},
    { icon: <StackIcon name={"aws"} className="w-12" />, years: 2, label: 'AWS'},
    { icon: <StackIcon name={"terraform"} className="w-12" />, years: 2, label: 'Terraform'},
];

const Tools = () => (
    <div className="flex flex-col items-center mt-8">
        <h2 className="mb-6 text-3xl font-bold flex items-center gap-2">
            <span role="img" aria-label="briefcase">💼</span>
            Experience
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-4 md:flex flex-1 flex-col md:flex-row gap-2">
            {experienceData.map((exp) => (
                <div
                    key={exp.label}
                    className="flex flex-col items-center p-4 border border-gray-200 rounded-lg min-w-[100px] bg-gray-50"
                >
                    {exp.icon}
                    <span className="font-bold text-2xl my-2">
                        {exp.years}
                    </span>
                    {/* <span className="text-base text-gray-600">{exp.label}</span> */}
                </div>
            ))}
        </div>
    </div>
);

export default Tools;